<template>
    <div>
        <h3 class="order__subtitle cart__subtitle">Способ оплаты</h3>

        <template v-for="(payment, paymentId) in paymentItems">
            <div v-if="payment['ITEMS_COUNT'] > 1 || (payment['ITEMS_COUNT'] === 1 && payment.ITEMS[0]['IMAGE'])"
                 class="cart__wrap order__item"
                 :class="{'order__item--active' : payment.ITEMS[0]['ID'] === currentPaySystem}"
                 :key="'item_' + paymentId"
                 :id="payment.ITEMS[0]['ID']"
                 :data-element="$root.getDataElement('cart_set_payment' + payment.ITEMS[0]['ID'])"
                 @click="setPayment(payment.ITEMS[0]['ID'])">
                <div class="cart__row">
                    <div
                        class="order__label cart__grow"
                    >
                        <div class="flx">
                            <div class="cart__grow">
                                <div class="cart__name">
                                    {{ payment.NAME }}
                                </div>
                            </div>
                            <template v-for="(paySys, paySysId) in payment.ITEMS">
                                <div v-if="paySys['IMAGE'] !== ''"
                                     class="cart__right"
                                     :key="'paySysId_' + paySysId">
                                    <img :src="paySys['IMAGE']" :alt="payment.NAME" class="va-middle">
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>

            <div v-else-if="payment['ITEMS_COUNT'] > 0 && (payment.ITEMS[0].ID !== payLaterId || isActiveUser)"
                 class="cart__wrap order__item"
                 :class="{'order__item--active' : payment.ITEMS[0]['ID'] === currentPaySystem}"
                 :key="paymentId"
                 :id="payment.ITEMS[0]['ID']"
                 :data-element="$root.getDataElement('cart_set_payment' + payment.ITEMS[0]['ID'])"
                 @click="setPayment(payment.ITEMS[0]['ID'])">
                <div class="cart__row">
                    <div
                        class="order__label cart__grow"
                    >
                        <div class="flx">
                            <div class="cart__grow">
                                <div class="cart__name">
                                    {{ payment.NAME }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                v-else-if="((payment['ITEMS_COUNT'] > 0 && payment.ITEMS[0].ID === payLaterId && paymentLater) || (isActiveUser && paymentLater))"
                :key="'payment_later_' + paymentId">
                <button class="order__later"
                        :class="{'order__later--active': payLaterNoteVisible || payment.ITEMS[0]['ID'] === currentPaySystem}"
                        :data-element="$root.getDataElement('cart_toggle_pay_later')"
                        @click="togglePayLater">
                    Хочу оплатить позднее
                    <i class="ui ui-arr-down"></i>
                </button>
                <div class="order__hidden"
                     :class="{'order__hidden--active': payLaterNoteVisible || payment.ITEMS[0]['ID'] === currentPaySystem}">
                    <div v-if="payLaterNoteVisible"
                         class="order__note"
                         v-html="payLaterNote">
                    </div>
                    <div :id="payment.ITEMS[0]['ID']"
                         class="cart__wrap order__item order__item--payment"
                         :class="{'order__item--active' : payment.ITEMS[0]['ID'] === currentPaySystem}"
                         :data-element="$root.getDataElement('cart_submit_pay_later')"
                         @click="setPayment(payment.ITEMS[0]['ID'])">
                        <div class="cart__row">
                            <div
                                class="order__label cart__grow"
                            >
                                <div class="flx">
                                    <div class="cart__grow">
                                        <div class="cart__name">
                                            {{ paymentLater['NAME'] }}
                                        </div>
                                        {{ paymentLater['DESC'] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-undef */

import api from '../../../../lib/api'

export default {
    name: "PaymentComponent",
    data() {
        return {
            paymentItems: {},
            payLaterId: null,
            isActiveUser: false,
            currentPaySystem: null,
            payLaterSelected: false,
            payLaterNote: '',
            payLaterNoteVisible: false,
            loader: true,
        }
    },
    computed: {
        paymentLater() {
            if (this.payLaterId && Array.isArray(this.paymentItems)) {
                if (this.isMobile) {
                    const payment = this.paymentItems.find(payment => payment.ID === this.payLaterId)
                    if (payment) {
                        return payment
                    }
                } else {
                    if (!this.isActiveUser) {
                        const payment = this.paymentItems.find(payment => payment.ITEMS.length > 0 && payment.ITEMS[0].ID === this.payLaterId)
                        if (payment) {
                            return payment
                        }
                    }
                }
            }
            return null
        }
    },
    methods: {
        togglePayLater() {
            this.payLaterNoteVisible = !this.payLaterNoteVisible
        },
        createLoader(bool) {
            this.loader = bool;
            this.$emit('createLoader', 'payment', this.loader)
        },
        setPayment(paySysId) {
            this.createLoader(true)
            this.currentPaySystem = paySysId;

            api.request('/api/cart-confirm/setPayment/', 'get', {'paySysId': paySysId}).then(() => {
                this.$emit('checkPayLatter', paySysId)
                this.createLoader(false);
            }).catch(() => {
                this.createLoader(false);
            });
        },
    },
    mounted() {
        api.request('/api/cart-confirm/getPayment/', 'get').then((response) => {
            this.paymentItems = response.data['paymentItems'];
            this.currentPaySystem = response.data['currentPaySystem'];
            this.isActiveUser = response.data['isActiveUser'];
            this.payLaterId = response.data['payLaterId'];
            this.payLaterNote = response.data['payLaterNote'];

            if (typeof window.fbq !== 'undefined') {
                fbq('track', 'CompleteRegistration');
            }

            this.createLoader(false);
        }).catch(() => {
            this.createLoader(false);
        });
    }
}
</script>